import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Checkbox, Col, Form, Modal, Row, Steps } from "antd";
import Step2 from "../../ExplorebyGoals/Components/Step2";
import Step3 from "../../ExplorebyGoals/Components/Step3";
import Step4 from "../../ExplorebyGoals/Components/Step4";
import { useDispatch, useSelector } from "react-redux";
import { nextStep } from "../../../Redux/tutorialSlice";
import { CloseOutlined } from "@ant-design/icons";
import { IoGrid, IoListOutline, IoPrintOutline } from "react-icons/io5";

function NonGeoCheck() {
  const [step, setStep] = useState(0);
  const [previousPreference, setPreviousPreference] = useState(false);
  const [checkPassed, setCheckPassed] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { landCoverSelections, prioritySelections, rankingScore } = useSelector(
    (state) => state.filter
  );
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { isTutorialActive, currentStep } = useSelector(
    (state) => state.tutorial
  );
  const getLabels = {
    winderosion: "Wind Erosion",
    watererosion: "Water Erosion",
    soilhealth: "Soil Health",
    excesswind: "Excess Wind",
    drought: "Drought",
    elevatedwatertemperature: "Water Temperature",
    flooding: "Flooding",
    snowdrift: "Snow Drift",
    waterquality: "Water Quality",
    aquatic: "Aquatic",
    biggame: "Big Game",
    grasslandbirds: "Grassland Birds",
    forestbirds: "Forest Birds",
    pollinators: "Pollinators",
    waterfowl: "Waterfowl",
    carbonstorage: "Carbon Storage",
    aquaculture: "Aquaculture Ponds",
    cropland: "Cropland",
    // timber: "Timber",
    pasture: "Pasture",
    wetland: "Wetland",
  };

  useEffect(() => {
    if (isTutorialActive && currentStep === 35) {
      setCheckPassed(true);
    }
    if (isTutorialActive && [36, 37, 38].includes(currentStep)) {
      setStep(0);
      setCheckPassed(false);
    }
    if (isTutorialActive && currentStep === 40) {
      setStep(1);
      setCheckPassed(false);
    }
  }, [currentStep, isTutorialActive]);

  const dispatch = useDispatch();

  const handleOk = () => {
    if (isTutorialActive && currentStep === 38) {
      dispatch(nextStep());
    }

    if (step === 0) {
      if (previousPreference) {
        setStep(1);
      } else {
        setStep(2);
      }
    } else if (step === 2) {
      setStep(3);
    } else if (step === 3) {
      setStep(4);
    } else if (step === 4) {
      setCheckPassed(true);
    }
  };

  const handleCancel = () => {
    if (step === 0) {
      setCheckPassed(false);
      setShowAlert(true);
    } else {
      setCheckPassed(true);
    }
  };

  const confirmPreviousPreference = () => {
    if (isTutorialActive && currentStep === 40) {
      dispatch(nextStep());
    }
    setCheckPassed(true);
  };

  const editPreviousPreference = () => {
    setStep(2);
  };

  const prev = () => {
    setStep(step - 1);
  };

  const next = () => {
    setStep(step + 1);
  };

  const items = [
    { title: "Location" },
    { title: "Land" },
    { title: "Priority" },
    { title: "Ranking" },
  ];

  useEffect(() => {
    if (
      (landCoverSelections?.length || 0) > 0 ||
      (prioritySelections?.length || 0) > 0
    ) {
      setPreviousPreference(true);
    }
  }, [landCoverSelections, prioritySelections]);

  return (
    <>
      {
        <Modal
          className="filter-modal"
          width="60vw"
          centered={true}
          open={!checkPassed}
          //onOk={handleOk}
          onCancel={handleCancel}
          closeIcon={step > 0 ? <CloseOutlined /> : null}
          //closeIcon={null}
          //okText={step === 0 ? "Acknowledge" : "OK"}
          //okButtonProps={{ style: { display: step === 1 ? "none" : "block" } }}
          //cancelButtonProps={{ style: { display: "none" } }}
          footer={[
            step === 0 ? (
              <Button
                style={{
                  margin: "0 8px",
                }}
                type="primary"
                onClick={() => handleOk()}
              >
                Acknowledge
              </Button>
            ) : (
              ""
            ),
            step > 1 ? (
              <Button
                style={{
                  margin: "0 8px",
                }}
                onClick={() => prev()}
              >
                Back
              </Button>
            ) : (
              ""
            ),
            step > 1 && step < 4 ? (
              <Button
                className="location-sel-next"
                style={{ float: "right" }}
                type="primary"
                onClick={() => next()}
              >
                Next
              </Button>
            ) : (
              ""
            ),
            step === 4 ? (
              <Button
                className="confirm-tutorial"
                style={{ float: "right" }}
                type="primary"
                onClick={() => handleOk()}
              >
                Confirm
              </Button>
            ) : (
              ""
            ),
          ]}
        >
          <div className="nongeocheck-popup">
            {step === 0 && (
              <>
                <h2>
                  Please confirm the eligibility requirements below before
                  proceeding
                </h2>
                {!showAlert && (
                  <Alert
                    // message={<b>Attention</b>}
                    description={
                      <p>
                        Cropland being considered for the CRP has been planted
                        or considered planted to an agricultural commodity for
                        four of the six crop years from 2012 to 2017.
                        <br />
                        <br />
                        You have owned or operated the land being considered for
                        the CRP for at least 12 months.
                        <br />
                        <br />
                        To be eligible for payments, your Certified Adjusted
                        Gross Income (AGI) must be less than $900,000 for the
                        last three taxable years.
                        <br />
                        <br />
                        To be eligible for enrollment, you must present the land
                        deed that identifies the owner of the land.
                        <br />
                        <br />
                        Please contact your local USDA office for more details
                        about eligibility.
                      </p>
                    }
                    type="warning"
                    showIcon={false}
                    closable={false}
                  />
                )}
                <Form form={form} id="nonGeoCheckForm">
                  <div className="nongeocheck-form mt-1">
                    <Form.Item name="generalDisclaimer" valuePropName="checked">
                      <span style={{ color: "red" }}>*</span>I acknowledge that
                      all information by or on this site is provided for{" "}
                      <b> informational purposes only </b>
                      and is not to be relied upon as a formal contractual offer
                      or used as fact in contractual negotiations. Please
                      contact your local USDA office for more information.
                    </Form.Item>
                  </div>
                </Form>
                {showAlert && (
                  <Alert
                    message="Error"
                    description="Please confirm you have read the mandatory disclaimer and click the Acknowledge button to proceed.!"
                    type="error"
                    showIcon
                    closable
                  />
                )}
              </>
            )}

            {step === 1 && (
              <>
                <Row className="mt-1 previous-selections">
                  <p>
                    <h3>You have previously selected:</h3>
                    <ul>
                      <li>
                        <b>Land Cover Type: </b>
                        <b style={{ color: "maroon" }}>
                          {landCoverSelections
                            .map((item) => getLabels[item])
                            .join(", ")}
                        </b>
                      </li>
                      <li>
                        <b>Priorities: </b>
                        <b style={{ color: "maroon" }}>
                          {prioritySelections
                            .map((item) => getLabels[item])
                            .join(", ")}
                        </b>
                      </li>
                    </ul>
                  </p>
                  <p>
                    Would you like to continue with these selections? Click{" "}
                    <b>"Edit"</b> to make changes to these selections. Click{" "}
                    <b>"Confirm"</b> to proceed with these selections.
                  </p>
                </Row>
                <Row className="mt-1 nongeocheck-button-container">
                  <Button
                    className="nongeocheck-button"
                    onClick={editPreviousPreference}
                  >
                    Edit
                  </Button>
                  <Button
                    className="nongeocheck-button tutorial-confirm"
                    onClick={confirmPreviousPreference}
                  >
                    Confirm
                  </Button>
                </Row>
              </>
            )}
            {step > 1 && (
              <Row>
                <Col>
                  <Steps
                    className="wizard-steps"
                    current={step - 1}
                    items={items}
                  />
                  <div className="wizard-steps-internal">
                    {step === 2 && <Step2 />}

                    {step === 3 && <Step3 />}

                    {step === 4 && <Step4 />}
                  </div>
                </Col>
              </Row>
            )}
          </div>
        </Modal>
      }
    </>
  );
}

export default NonGeoCheck;
